import React from 'react';
import { useCallback } from 'react';
import _ from 'lodash';
import { FormControl, Switch, FormLabel, Box, Tooltip, Flex } from '@chakra-ui/react';
import { selectComponent, selectedComponent } from '../../redux/selectedComponentSlice';
import { updateComponent } from '../../redux/pagesSlice';
import { selectedPage } from '../../redux/selectedPageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { findCompByIdRecursively } from '../../utils/functions';
import { UilQuestionCircle } from '@iconscout/react-unicons';

export const getSwitchValues = ({ propValue }) => {
	return propValue;
};

const EditorSwitch = ({ propName, tooltip, title, values, componentId, arrayIndex, originalPropname }) => {
	const [options, setOptions] = React.useState({ title, values });
	const selectedPageValue = useSelector(selectedPage);
	const selectedComponentValue = useSelector(selectedComponent);
	const dispatch = useDispatch();
	const debounceFn = useCallback(_.debounce(handlePagesUpdate, 0), [
		selectedPageValue,
		componentId,
		selectedComponentValue,
	]);

	function handlePagesUpdate(value) {
		const newSelectedComponent = JSON.parse(JSON.stringify(selectedComponentValue));
		const { comp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);
		if (typeof comp.props[propName] === 'object') {
			comp.props[propName][title] = value;
		} else if (originalPropname) {
			if (typeof comp.props[originalPropname][arrayIndex][propName] === 'object') {
				comp.props[originalPropname][arrayIndex][propName][title] = value;
			} else {
				comp.props[originalPropname][arrayIndex][propName] = value;
			}
		} else {
			comp.props[propName] = value;
		}
		dispatch(
			updateComponent({
				component: comp,
				componentId,
				pageId: selectedPageValue,
			}),
		);

		if (newSelectedComponent?.childComp) {
			const { comp: originalComp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);
			originalComp.props = JSON.parse(JSON.stringify(comp.props));
		}

		//precisa disso pro componente renderizar corretamente se alterar + de 1 prop
		dispatch(selectComponent(newSelectedComponent));
	}

	function handleChange(e) {
		const value = e.target.checked;
		const newOptions = JSON.parse(JSON.stringify(options));
		newOptions.values = value;
		setOptions(newOptions);
		debounceFn(value);
	}

	return (
		<Flex className="mz-hef-edit" flex={'1 1 49%'} maxW={'49%'} flexDir="column">
			<label
				className="mz-hef-edit-label"
				flexGrow={1}
				d={'flex'}
				alignItems={'center'}
				justifyContent={'space-between'}
				mr={2}
				mb={0}
				borderColor={'gray.200'}
				fontFamily={'Poppins'}
				color={'gray.700'}
				fontWeight="bold"
				fontSize={'sm'}
			>
				<Box display={'inline-block'}>{options.title}</Box>
				<Box d="flex" justifyContent="space-between">
					<Switch isChecked={options.values} onChange={(e) => handleChange(e)} colorScheme={'yellow'} size="md" />
				</Box>
			</label>

			{/* {!!tooltip && (
                    <Tooltip fontSize="xs" label={tooltip}>
                        <Box display={"inline-block"}>
                            <UilQuestionCircle size="16" />
                        </Box>
                    </Tooltip>
                )} */}
		</Flex>
	);
};

export default EditorSwitch;
